<template>
  <div class="home-box">
    <el-breadcrumb class="bread-box" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item id="first-class-menu">{{ firstMenuMapMutation[firstId].name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- {{firstId}},{{firstActiveIndex}} -->
    <contentBox :styleType="currentType" :content="currentDataContent"></contentBox>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { dotdot } from '../utils/common';
import contentBox from '../pages/content';
export default {
  name: 'secondClass',
  data() {
    return {
      routerName: this.$route.name,
      firstActiveIndex: this.$route.params.firstActiveIndex || '0',
      firstId: this.$route.params.firstId,
      menuDataList: {},
      currentType: '',
      currentDataImage: [],
      currentDataContent: {},

      articleListData: [],
      articleTotal: 0,
      pagination: {
        page: 1,
        pageSize: 10,
      },
    };
  },
  components: {
    contentBox,
  },
  computed: {
    ...mapGetters([
      'systemName',
      'baseImageUrl',
      'firstMenuMutation',
      'firstMenuMapMutation',
      'secondMenuMutation',
      'secondMenuMapMutation',
      'thirdMenuMutation',
      'thirdMenuMapMutation',
    ]),
  },
  created() {
    this.initData();
  },
  mounted() {
    // console.log(this.secondMenuMapMutation, '777777777')
    // console.log(this.activeIndex, this.menuListData, 'this.activeIndex');
  },
  watch: {
    $route(to, from) {
      console.log('66666666666666666======');
      console.log(this.firstMenuMapMutation[this.firstId], '777777777');
      this.firstActiveIndex = this.$route.params.firstActiveIndex;
      this.firstId = this.$route.params.firstId;
    },
  },
  methods: {
    ...mapActions(['menuIdContent', 'getRichTextContentPage']),
    initData() {
      this.menuIdContent({ id: this.firstId }).then((res) => {
        console.log(res, 'saucxs================6666');
        if (res.success) {
          this.currentType = String(res.data.styleType);
          if (this.currentType === '7') {
            this.currentDataContent = res.data;
          } else if (this.currentType === '2' || this.currentType === '3' || this.currentType === '8') {
            this.currentDataContent = {
              data: res.data.data
            }
          } else if (this.currentType === '1' || this.currentType === '4' || this.currentType === '5' || this.currentType === '6') {
            this.currentDataContent = res.data.data;
          } else {
            this.currentDataContent = res.data.data;
          }
        }
      });
    },
    goArticleContent(articleId) {
      this.$router.push(`/article/${this.firstActiveIndex}/${this.firstId}/${articleId}`);
    },
    // 表格分页
    handleCurrentChange(val) {
      this.getRichTextContentPage({ menuId: this.firstId, pageSize: 10, pageNo: val }).then(
        (res) => {
          if (this.currentType === 'TABLE_PAGE') {
            this.articleListData = res.data.records;
            this.articleTotal = res.data.total;
          }
        },
      );
    },
  },
};
</script>

<style lang="less" scoped>
.home-box {
  width: 100%;
  .content-box {
    img {
      width: 100% !important;
      width: 100% !important;
    }
  }
  .pagenation-box {
    text-align: center;
    margin: 0.2rem 0;
  }
  .second-menu-box {
    .box-container {
      display: flex;
      justify-content: flex-start;
      .box-item {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        padding: 0.2rem;
        margin: 0 0.2rem 0.2rem 0;
        text-align: center;
        .icon-middle {
          margin: 0 auto;
        }
      }
      .active-box-item {
        text-align: center;
        border-bottom: 2px solid #409eff;
        color: #409eff;
      }
      .font-menu {
        font-size: 0.24rem;
        font-weight: bold;
      }
    }
    // 图片列表
    .image-box,
    .article-content-list-box {
      padding: 0.4rem 0rem;
      .image-item-box {
        padding: 0.14rem;
        // margin: 0 0.2rem 0.2rem 0;
      }
      .article-item-box {
      }
      .image-item {
        width: 100%;
      }
    }
    // 富文本
    .rich-content-box {
      padding: 0.2rem;
    }
    .title-name {
      text-align: center;
      font-size: 0.4rem;
    }
    .flex-box {
      display: flex;
      justify-content: space-around;
      font-size: 0.22rem;
      color: #949494;
    }
    .box-list-style {
      padding: 0.16rem;
      cursor: pointer;
      height: 2rem;
    }
    .title-box {
      font-size: 0.24rem;
      font-weight: bold;
      margin-bottom: 0.2rem;
      color: #409eff;
    }
    .box-item-content {
      font-size: 0.2rem;
    }
    .box-list-style:hover {
      background: #eee;
      color: #409eff;
    }
    // 有轮播图的picture
    .has-picture-box {
      padding: 0.3rem 0;
      img {
        width: 100%;
        height: 100%;
      }
      .box-list-style {
        padding: 0 0.1rem 0.2rem;
      }
      .article-content-list-box {
        padding: 0 0 0 0.2rem;
      }
      .box-list-style {
        height: auto;
      }
      .time-box {
        font-size: 0.14rem;
        font-weight: inherit;
        color: #797979;
        margin-bottom: 0.06rem;
      }
      .title-box {
        margin-bottom: 0;
        font-size: 0.22rem;
        font-weight: inherit;
      }
      .pagenation-box {
        text-align: center;
        margin: 0.1rem 0;
      }
    }
    .main-product-box {
      margin-top: 0.6rem;
      .main-product-title {
        font-size: 0.4rem;
        text-align: center;
        margin-bottom: 0.24rem;
      }
      .main-product-content {
        font-size: 0.22rem;
        padding: 0.4rem;
        background: #f5f5f5;
        border-radius: 0.1rem;
      }
    }
    .main-buju-box {
      margin-top: 1rem;
      .item-title {
        font-size: 0.4rem;
        text-align: center;
        margin-bottom: 0.24rem;
        // color: #409eff;
      }
      .main-buju-item {
        display: flex;
        margin-bottom: 0.8rem;
        justify-content: space-evenly;
        flex-wrap: wrap;
        .item-content {
          font-size: 0.34rem;
          padding: 0.4rem;
          background: #f9f9f9;
          border-radius: 0.1rem;
          width: 3rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .item-content:hover {
          background: #409eff;
          color: #fff;
        }
      }
    }
  }
}
</style>
